import moment from 'moment';
import { noop, random } from 'lodash';

export const NOOP = noop;

export const guid = () => `${random(10000, 100000)}-${random(10000, 100000)}-${random(10000, 100000)}`;

export const formatPrice = (number, options = {}) => {
  // eslint-disable-next-line compat/compat
  const formatter = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options,
  });
  return formatter.format(number);
};

export const formatCurrency = (number) => formatPrice(number, {
  style: 'currency',
  currency: 'EUR',
});


export const sleep = async (ms) => new Promise(resolve => setTimeout(resolve, ms));


export const formatDate = (date, format = 'DD.MM.YYYY') => {
  return moment(date).format(format);
};

export const getCardType = (cardType) => {
    if(!cardType) return '';
    switch (cardType.toLowerCase()) {
      case 'sepa':
        return 'sepa';
      case 'master card':
      case 'master':
        return 'mastercard';
      case 'amex':
        return 'american-express';
      case 'diners club':
      case 'dinersclub':
      case 'diners':
        return 'diners-club';
      case 'discover':
        return 'discover';
      case 'jcb':
        return 'jcb';
      default:
        return 'visa';
    }
};